import React, { Component } from 'react';
import { Tooltip as UncontrolledTooltip } from "recharts";
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom'
import Modal from '../ComplianceModal'
import HelpTextModal from '../HelpTextModal'
import { Field, reduxForm, change } from 'redux-form';
import renderSelectField from '../Select';
import Moment from 'moment';
import { connect } from 'react-redux';
import uuid from 'uuid';
import renderDatePickerField from '../form/DatePicker';
import CalendarBlankIcon from 'mdi-react/CalendarBlankIcon';
import { Mutation } from 'react-apollo';
import { loadCompliance } from '../../redux/actions/complianceActions';
import { withApollo } from 'react-apollo';
import {
  SetCompliant,
  SetReadyReview,
  SetNotApplicable,
  SetNotCompliant,
  SetDueDate,
  SetAssignedTo,
  SetUnassigned,
  SetNotSet,
  SetAwaitingEvidence,
  SetStatusV2,
  SetAssignedToV2,
  SetDueDateV2,
  GetHelpText
} from '../../queries/controls'
import { signout } from '../../redux/actions/userActions';
import { ControlAssetIcon, ControlSecurityIcon } from '../../utils/iconMapping'
import $ from 'jquery';

const stateOptions = [
  { value: 1, label: 'Compliant', qldbLabel: 'COMPLIANT'  },
  { value: 2, label: 'Not Compliant', qldbLabel: 'NOT_COMPLIANT' },
  { value: 3, label: 'Ready for Review', qldbLabel: 'READY_FOR_REVIEW' },
  { value: 4, label: 'Not Applicable', qldbLabel: 'NOT_APPLICABLE' },
  { value: 5, label: 'Awaiting Evidence', qldbLabel: 'AWAITING_EVIDENCE' },
  { value: 6, label: 'Not Set', qldbLabel: 'NOT_SET' },
]

const initialState = {
  expanded: false,
  assignee: null,
  status: { value: 6, label: 'Not Set', qldbLabel: 'NOT_SET' },
  dueDate: null,
  open: false,
  hOpen: false,
  helpTextData: {},
  comment: ''
}

class RenderRow extends Component {
  state = initialState

  componentDidMount () {
    const { status } = this.props;
    let currentStatus = 6;
    let dueDate = Moment();
    let users = [{ value: 0, label: 'Unassigned' }];

    this.props.users.map((user, i) => {
      return users.push({ value: user.sub, label: `${user.given_name} ${user.family_name}`, email: user.email });
    });
    const currUser = (status && status.assignedTo) ?
      users.filter(user => user.value === status.assignedTo)[0] :
      users[0];

    if (status) {

      if (status.status) {
        currentStatus = stateOptions.filter(o => {
          return o.qldbLabel === this.props.status.status
        })[0].value
      }
      if (status.dueDate) {
        dueDate = new Date(this.props.status.dueDate).toISOString()
      }

      this.setState({
        assignee: currUser || users[0],
        status: currentStatus,
        dueDate: dueDate
      })
    } else {
      this.setState({
        assignee: users[0],
        dueDate: Moment(),
        status: currentStatus
      });
    }

    // if (this.props.selected) this.getControlInView(this.props.control.controlID);
  }

  updateStatus (status) {
    //Status change
    let statusIndex = stateOptions.findIndex(o => {
      return o.label === status.status
    })
    if (statusIndex >= 0) {
      this.setState({
        status: { value: stateOptions[statusIndex].value, label: stateOptions[statusIndex].label }
      })
    }
  }

  getHelpTextData = (controlID) => {
    (async () => {     
        const { data: helpTextData } = await this.props.client.query({
          query: GetHelpText(),
          fetchPolicy: 'network-only',
          context: { tenantID: this.props.user["custom:tenant"] },
          variables: {
            'controlID':controlID
            }
        })
        
        if(helpTextData){
          this.setState({
            helpTextData: {data: helpTextData.helpText? helpTextData.helpText.helpText : null,
            controlId: helpTextData.helpText? helpTextData.helpText.controlId : null},
            hOpen: true
          });
        }
        else{
          this.setState({
            helpTextData:{
              data:null,
              controlId:null
            },
            hOpen:true
          })
        }
    })().catch(error => {
      console.log(error)
    })
  }

  componentDidUpdate (prevProps, prevState) {
    const { status } = this.props;
    let currentStatus = 6;
    let dueDate = Moment();

    if (prevProps.status !== status && prevProps.status === null) {
      let users = [{ value: 0, label: 'Unassigned' }];
      this.props.users.map((user, i) => {
        return users.push({ value: user.sub, label: `${user.given_name} ${user.family_name}`, email: user.email });
      });
      const currUser = (status && status.assignedTo) ?
        users.filter(user => user.value === status.assignedTo)[0] : users[0];


      if (this.props.status.status) {
        currentStatus = stateOptions.filter(o => {
          return o.qldbLabel === this.props.status.status
        })[0].value
      }

      if (status.dueDate) {
        dueDate = new Date(this.props.status.dueDate).toISOString()
      }

      this.setState({
        assignee: currUser === 'undefined' ? users[0] : currUser,
        status: currentStatus,
        dueDate: dueDate
      })
    }

    if (this.props.selected && prevState === initialState) this.getControlInView(this.props.control.controlNanoID);

    // if ((this.props.sidebar.show && window.screen.width < 1520 && window.screen.width > 1024)) {
    //   $('.compliance-select-field .Select-control').attr('style', 'width: 110px !important')
    //   $('.form__form-group-datepicker').attr('style', 'width: 95px !important')
    // } else {
    //   $('.compliance-select-field .Select-control').removeAttr('style')
    //   $('.form__form-group-datepicker').removeAttr('style')
    // }
  }

  renderDate (date) {
    const today = Moment(Date.now());
    const deadline = today.clone().add(4, 'days').startOf('day');

    return (deadline.diff(today, 'days')) < 3 ?
      <p style={{ color: '#F00' }}>{date}</p> : <p style={{ color: '#0B6623' }}>
        {date}
      </p>
  }

  determineControlStatus(){
    if(this.props.status == null){
      return "Not Set"
    }
    if(this.props.status.status == null){
      return "Not Set"
    }
    return this.props.status.status
  }

  determineAssignedTo(){
    if(this.props.status == null){
      return 'Unassigned'
    }
    if (this.props.status.assignedTo == null){
      return 'Unassigned'
    }
    return this.props.status.assignedTo
  }

  determinedueDate(){
    if(this.props.status == null){
      return new Date().getTime()
    }
    if(this.props.status.dueDate == null){
      return new Date().getTime()
    }
    return this.props.status.dueDate
  }

  parseDesc () {
    let splitter = ':';
    let splitDesc = this.props.control.description.split(':');

    if (splitDesc.length < 2) {
      splitDesc = this.props.control.description.split('?');
      splitter = '?'
    }

    if (splitDesc.length < 2) {
      splitter = ''
    }

    const getList = splitDesc[1] ? splitDesc[1].split(/[0-9]*\.\s/gm) : [];
    const trimmedArray = getList.filter(item => {
      return item.trim().length > 0
    });

    return <div>
      <p><b>{`${splitDesc[0]}${splitter}`}</b></p>
      {trimmedArray.map((item, i) => {
        return <p key={uuid()}> {`${i + 1}. ${item.trim()}`} </p>
      })
      }
    </div>
  }

  getQuestion () {
    let splitter = ':';
    let splitDesc = this.props.control.description.split(':');

    if (splitDesc.length < 2) {
      splitDesc = this.props.control.description.split('?');
      splitter = '?'
    }

    if (splitDesc.length < 2) {
      splitter = ''
    }

    return `${splitDesc[0]}${splitter}`
  }

  clearCommentField () {
    this.props.dispatch(change('render-row', 'textarea', ''))
  }

  signoutUser () {
    this.props.signout();
    this.props.history.push('/');
  }

  getControlInView (i) {
    // const step = 300 + (i * 80);
    $(`html, body`).animate({
      scrollTop: $(`#${i}`).offset().top - 70
    });
  }

  render () {
    const { control } = this.props;
    let users = [{ value: 0, label: 'Unassigned' }];
    this.props.users.map((user, i) => {
      return users.push({ value: user.sub, label: `${user.given_name} ${user.family_name}`, email: user.email });
    });

    const description = this.props.parse === true && control.description ? this.parseDesc() : control.description
    const advice = control.advice

    return (
      this.state.assignee ?
        <tr className="control-row" id={this.props.control.controlNanoID}>
          <td style={{ fontWeight: 400, textAlign: 'center' }} className="mobile-hide">
            {control.referenceID}
            <div
              id={`security-${this.props.control.controlNanoID}`}
              style={{ marginTop: 10, marginBottom: 15 }}>
              <ControlSecurityIcon
                type={control.securityFunction} /></div>
            <UncontrolledTooltip
              placement='bottom'
              target={`security-${this.props.control.controlNanoID}`}>
              {`${control.securityFunction} your devices`}
            </UncontrolledTooltip>

            <div
              id={`asset-${this.props.control.controlNanoID}`}>
              <ControlAssetIcon type={control.assetType} />
            </div>
            <UncontrolledTooltip
              className='tooltip'
              placement='bottom'
              target={`asset-${this.props.control.controlNanoID}`}>
              {`Asset type: ${control.assetType}`}
            </UncontrolledTooltip>
          </td>
          <td >
            <div className="mobile-group">
              <p className="rule">{control.referenceID}</p>
            </div>
            {description || description !== null ?
              <span style={{ fontWeight: 700 }}>
                {description}
              </span>
              :
              null}
            {advice || advice !== null ? <span style={{ fontWeight: 400 }}>
              {advice}
              <br />
            </span>
              :
              null}
          </td>
          <td>
            <div className="mobile-group mobile-dropdwon-title">
              <p>Assigned To</p>
            </div>
            <div className='form__form-group'>
              <div className='form__form-group-field comp-controls'>
                <Mutation mutation={SetAssignedToV2()}>
                  {(controlState, {data}) => (
                  <Mutation mutation={SetAssignedTo()}>
                    {(assignControl, { data }) => (
                      <Mutation mutation={SetUnassigned()}>
                        {(unassignControl, { data }) => (
                          <div id={`assigned-to-${this.props.control.controlNanoID}`}>
                            <Field
                              name='select'
                              className='compliance-select-field'
                              component={renderSelectField}
                              options={users}
                              onChange={(newAssignee) => {
                                if (newAssignee.label === 'Unassigned') {
                                  unassignControl({
                                    variables: {
                                      controlData: {
                                        "framework": this.props.framework,
                                        "highLevelCategory": this.props.humanHighLevelCategory,
                                        "lowLevelCategory": this.props.lowLevelCategory,
                                        "controlID": this.props.control.controlNanoID,
                                        "referenceID": this.props.control.referenceID
                                      }
                                    }
                                  })

                                  controlState({
                                    variables:{
                                      controlData:{
                                        "controlId":`${this.props.control.controlNanoID}`,
                                        "categoryId":null,
                                        "assignedTo": newAssignee.label,
                                        "frameworkId":`${this.props.control.frameworkID}`,
                                        "referenceId":this.props.control.referenceID,
                                        "sectionId":`${this.props.control.lowLevelCategoryNanoID}`,
                                        "tenantId":this.props.user['custom:tenant'],
                                        "updatedBy":this.props.user.sub
                                      }
                                    }
                                  })

                                } else {
                                  assignControl({
                                    variables: {
                                      controlData: {
                                        "framework": this.props.framework,
                                        "highLevelCategory": this.props.humanHighLevelCategory,
                                        "lowLevelCategory": this.props.lowLevelCategory,
                                        "controlID": this.props.control.controlNanoID,
                                        "assignedTo": newAssignee.value,
                                        "email": newAssignee.email,
                                        "description": `${control.description || control.advice}`,
                                        "referenceID": this.props.control.referenceID
                                      }
                                    }
                                  })
                                 
                                  controlState({
                                    variables:{
                                      controlData:{
                                        "controlId":`${this.props.control.controlNanoID}`,
                                        "categoryId":null,
                                        "assignedTo": newAssignee.value,
                                        "frameworkId":`${this.props.control.frameworkID}`,
                                        "referenceId":this.props.control.referenceID,
                                        "sectionId":`${this.props.control.lowLevelCategoryNanoID}`,
                                        "tenantId":this.props.user['custom:tenant'],
                                        "updatedBy":this.props.user.sub
                                      }
                                    }
                                  })
                                }

                                this.setState({
                                  assignee: {
                                    value: newAssignee.value,
                                    label: newAssignee.label,
                                    email: newAssignee.email
                                  }
                                });
                              }}
                              defaultValue={this.state.assignee}
                              clearable={false}
                            />
                          </div>
                        )}
                      </Mutation>
                    )}
                  </Mutation>
                  
                  )}
                </Mutation>
              </div>
            </div>
            <div className="mobile-group mobile-dropdwon-title">
              <p>Due Date</p>
            </div>
            <div className='form__form-group mobile-group'>
              <div className='form__form-group-field comp-controls date'>
              <Mutation mutation={SetDueDateV2()}>
                {(controlState, {data}) => ( 
                    <div id={`due-date-${this.props.control.controlNanoID}`}>
                      <Field
                        name='default_date'
                        component={renderDatePickerField}
                        controlId={this.props.control.controlNanoID}
                        defaultValue={this.state.dueDate}
                        onChange={(newDate) => {
                          controlState({
                            variables:{
                              controlData:{
                                "controlId":`${this.props.control.controlNanoID}`,
                                "categoryId":null,
                                "dueDate":new Date(newDate.date).getTime(),
                                "frameworkId":`${this.props.control.frameworkID}`,
                                "referenceId":this.props.control.referenceID,
                                "sectionId":`${this.props.control.lowLevelCategoryNanoID}`,
                                "tenantId":this.props.user['custom:tenant'],
                                "updatedBy":this.props.user.sub
                              }
                            }
                          })
                          this.setState({ dueDate: new Date(newDate.date).toISOString() })
                          
                        }}
                      />
                    </div>
                  )}
                </Mutation>
                <div className='form__form-group-icon date'>
                  <CalendarBlankIcon /></div>
              </div>
            </div>
            <div className="mobile-group mobile-dropdwon-title">
              <p>Status</p>
            </div>
            <div className='form__form-group mobile-group'>
              <div className='form__form-group-field comp-controls'>
              <Mutation mutation={SetStatusV2()}>
                {(controlState, {data}) => ( 
                <Mutation mutation={SetCompliant()}>
                  {(setCompliant, { setCompliantData }) => (
                    <Mutation mutation={SetNotCompliant()}>
                      {(setNotCompliant, { setNotCompliantData }) => (
                        <Mutation mutation={SetReadyReview()}>
                          {(setReadyReview, { setReadyReviewData }) => (
                            <Mutation mutation={SetNotApplicable()}>
                              {(setNotApplicable, { setNotApplicableData }) => (
                                <Mutation mutation={SetAwaitingEvidence()}>
                                  {(setAwaitingEvidence, { setAwaitingEvidenceData }) => (
                                    <Mutation mutation={SetNotSet()}>
                                      {(setNotSet, { setNotSetData }) => (
                                        <div id={`status-${this.props.control.controlNanoID}`}>
                                          <Field
                                            name='selectStatus'
                                            className='compliance-select-field'
                                            onChange={(newStatus) => {
                                              const oldValue = this.state.status
                                              const newValue = newStatus.value
                                              this.setState({
                                                status: {
                                                  value: newStatus.value,
                                                  label: stateOptions[newStatus.value - 1].label
                                                }
                                              }, () => {
                                                switch (newValue) {
                                                  case 1:
                                                    this.props.handleStatusChange(
                                                      oldValue,
                                                      newValue,
                                                      this.props.lowLevelCategory)
                                                    setCompliant({
                                                      variables: {
                                                        controlData: {
                                                          "framework": this.props.framework,
                                                          "highLevelCategory": this.props.humanHighLevelCategory,
                                                          "lowLevelCategory": this.props.lowLevelCategory,
                                                          "controlID": this.props.control.controlNanoID,
                                                          "referenceID": this.props.control.referenceID
                                                        }
                                                      }
                                                    })
                                                    break;
                                                  case 2:
                                                    this.props.handleStatusChange(
                                                      oldValue,
                                                      newValue,
                                                      this.props.lowLevelCategory)
                                                    setNotCompliant({
                                                      variables: {
                                                        controlData: {
                                                          "framework": this.props.framework,
                                                          "highLevelCategory": this.props.humanHighLevelCategory,
                                                          "lowLevelCategory": this.props.lowLevelCategory,
                                                          "controlID": this.props.control.controlNanoID,
                                                          "referenceID": this.props.control.referenceID
                                                        }
                                                      }
                                                    })
                                                    break;
                                                  case 3:
                                                    this.props.handleStatusChange(
                                                      oldValue,
                                                      newValue,
                                                      this.props.lowLevelCategory)
                                                    setReadyReview({
                                                      variables: {
                                                        controlData: {
                                                          "framework": this.props.framework,
                                                          "highLevelCategory": this.props.humanHighLevelCategory,
                                                          "lowLevelCategory": this.props.lowLevelCategory,
                                                          "controlID": this.props.control.controlNanoID,
                                                          "referenceID": this.props.control.referenceID
                                                        }
                                                      }
                                                    })
                                                    break;
                                                  case 4:
                                                    this.props.handleStatusChange(
                                                      oldValue,
                                                      newValue,
                                                      this.props.lowLevelCategory)
                                                    setNotApplicable({
                                                      variables: {
                                                        controlData: {
                                                          "framework": this.props.framework,
                                                          "highLevelCategory": this.props.humanHighLevelCategory,
                                                          "lowLevelCategory": this.props.lowLevelCategory,
                                                          "controlID": this.props.control.controlNanoID,
                                                          "referenceID": this.props.control.referenceID
                                                        }
                                                      }
                                                    })
                                                    break;
                                                  case 5:
                                                    this.props.handleStatusChange(
                                                      oldValue,
                                                      newValue,
                                                      this.props.lowLevelCategory)
                                                    setAwaitingEvidence({
                                                      variables: {
                                                        controlData: {
                                                          "framework": this.props.framework,
                                                          "highLevelCategory": this.props.humanHighLevelCategory,
                                                          "lowLevelCategory": this.props.lowLevelCategory,
                                                          "controlID": this.props.control.controlNanoID,
                                                          "referenceID": this.props.control.referenceID
                                                        }
                                                      }
                                                    })
                                                    break;
                                                  case 6:
                                                    this.props.handleStatusChange(
                                                      oldValue,
                                                      newValue,
                                                      this.props.lowLevelCategory)
                                                    setNotSet({
                                                      variables: {
                                                        controlData: {
                                                          "framework": this.props.framework,
                                                          "highLevelCategory": this.props.humanHighLevelCategory,
                                                          "lowLevelCategory": this.props.lowLevelCategory,
                                                          "controlID": this.props.control.controlNanoID,
                                                          "referenceID": this.props.control.referenceID
                                                        }
                                                      }
                                                    })
                                                    break;
                                                  default:
                                                    break;
                                                }
                                              })
                                              this.setState({
                                                status: newValue
                                              });
                                              
                                              controlState({
                                                variables:{
                                                  controlData:{
                                                    "controlId":`${this.props.control.controlNanoID}`,
                                                    "categoryId":null,
                                                    "status": newStatus.qldbLabel,
                                                    "frameworkId":`${this.props.control.frameworkID}`,
                                                    "referenceId":this.props.control.referenceID,
                                                    "sectionId":`${this.props.control.lowLevelCategoryNanoID}`,
                                                    "tenantId":this.props.user['custom:tenant'],
                                                    "updatedBy":this.props.user.sub
                                                  }
                                                }
                                              })

                                            }}
                                            component={renderSelectField}
                                            options={stateOptions}
                                            defaultValue={this.state.status}
                                            clearable={false}
                                          />
                                        </div>
                                      )}
                                    </Mutation>
                                  )}
                                </Mutation>
                              )}
                            </Mutation>
                          )}
                        </Mutation>
                      )}
                    </Mutation>
                  )}
                </Mutation>
                )}
              </Mutation>
              </div>
            </div>
          </td>
          <td className="mobile-hide">
            <div className='form__form-group'>
              <div className='form__form-group-field comp-controls date'>
              <Mutation mutation={SetDueDateV2()}>
                {(controlState, {data}) => ( 
                    <div id={`due-date-${this.props.control.controlNanoID}`}>
                      <Field
                        name='default_date'
                        component={renderDatePickerField}
                        controlId={this.props.control.controlNanoID}
                        defaultValue={this.state.dueDate}
                        onChange={(newDate) => {
                          controlState({
                            variables:{
                              controlData:{
                                "controlId":`${this.props.control.controlNanoID}`,
                                "categoryId":null,
                                "dueDate":new Date(newDate.date).getTime(),
                                "frameworkId":`${this.props.control.frameworkID}`,
                                "referenceId":this.props.control.referenceID,
                                "sectionId":`${this.props.control.lowLevelCategoryNanoID}`,
                                "tenantId":this.props.user['custom:tenant'],
                                "updatedBy":this.props.user.sub
                              }
                            }
                          })
                          this.setState({ dueDate: new Date(newDate.date).toISOString() })

                        }}
                      />
                    </div>
                  )}
                </Mutation>
                <div className='form__form-group-icon date'>
                  <CalendarBlankIcon /></div>
              </div>
            </div>
          </td>
          <td className="mobile-hide">
            <div className='form__form-group'>
              <div className='form__form-group-field comp-controls'>
              <Mutation mutation={SetStatusV2()}>
                {(controlState, {data}) => (
                <Mutation mutation={SetCompliant()}>
                  {(setCompliant, { setCompliantData }) => (
                    <Mutation mutation={SetNotCompliant()}>
                      {(setNotCompliant, { setNotCompliantData }) => (
                        <Mutation mutation={SetReadyReview()}>
                          {(setReadyReview, { setReadyReviewData }) => (
                            <Mutation mutation={SetNotApplicable()}>
                              {(setNotApplicable, { setNotApplicableData }) => (
                                <Mutation mutation={SetAwaitingEvidence()}>
                                  {(setAwaitingEvidence, { setAwaitingEvidenceData }) => (
                                    <Mutation mutation={SetNotSet()}>
                                      {(setNotSet, { setNotSetData }) => (
                                        <div id={`status-${this.props.control.controlNanoID}`}>
                                          <Field
                                            name='selectStatus'
                                            className='compliance-select-field'
                                            onChange={(newStatus) => {
                                              const oldValue = this.state.status
                                              const newValue = newStatus.value
                                              this.setState({
                                                status: {
                                                  value: newStatus.value,
                                                  label: stateOptions[newStatus.value - 1].label
                                                }
                                              }, () => {
                                                switch (newValue) {
                                                  case 1:
                                                    this.props.handleStatusChange(
                                                      oldValue,
                                                      newValue,
                                                      this.props.lowLevelCategory)
                                                    setCompliant({
                                                      variables: {
                                                        controlData: {
                                                          "framework": this.props.framework,
                                                          "highLevelCategory": this.props.humanHighLevelCategory,
                                                          "lowLevelCategory": this.props.lowLevelCategory,
                                                          "controlID": this.props.control.controlNanoID,
                                                          "referenceID": this.props.control.referenceID
                                                        }
                                                      }
                                                    })
                                                    break;
                                                  case 2:
                                                    this.props.handleStatusChange(
                                                      oldValue,
                                                      newValue,
                                                      this.props.lowLevelCategory)
                                                    setNotCompliant({
                                                      variables: {
                                                        controlData: {
                                                          "framework": this.props.framework,
                                                          "highLevelCategory": this.props.humanHighLevelCategory,
                                                          "lowLevelCategory": this.props.lowLevelCategory,
                                                          "controlID": this.props.control.controlNanoID,
                                                          "referenceID": this.props.control.referenceID
                                                        }
                                                      }
                                                    })
                                                    break;
                                                  case 3:
                                                    this.props.handleStatusChange(
                                                      oldValue,
                                                      newValue,
                                                      this.props.lowLevelCategory)
                                                    setReadyReview({
                                                      variables: {
                                                        controlData: {
                                                          "framework": this.props.framework,
                                                          "highLevelCategory": this.props.humanHighLevelCategory,
                                                          "lowLevelCategory": this.props.lowLevelCategory,
                                                          "controlID": this.props.control.controlNanoID,
                                                          "referenceID": this.props.control.referenceID
                                                        }
                                                      }
                                                    })
                                                    break;
                                                  case 4:
                                                    this.props.handleStatusChange(
                                                      oldValue,
                                                      newValue,
                                                      this.props.lowLevelCategory)
                                                    setNotApplicable({
                                                      variables: {
                                                        controlData: {
                                                          "framework": this.props.framework,
                                                          "highLevelCategory": this.props.humanHighLevelCategory,
                                                          "lowLevelCategory": this.props.lowLevelCategory,
                                                          "controlID": this.props.control.controlNanoID,
                                                          "referenceID": this.props.control.referenceID
                                                        }
                                                      }
                                                    })
                                                    break;
                                                  case 5:
                                                    this.props.handleStatusChange(
                                                      oldValue,
                                                      newValue,
                                                      this.props.lowLevelCategory)
                                                    setAwaitingEvidence({
                                                      variables: {
                                                        controlData: {
                                                          "framework": this.props.framework,
                                                          "highLevelCategory": this.props.humanHighLevelCategory,
                                                          "lowLevelCategory": this.props.lowLevelCategory,
                                                          "controlID": this.props.control.controlNanoID,
                                                          "referenceID": this.props.control.referenceID
                                                        }
                                                      }
                                                    })
                                                    break;
                                                  case 6:
                                                    this.props.handleStatusChange(
                                                      oldValue,
                                                      newValue,
                                                      this.props.lowLevelCategory)
                                                    setNotSet({
                                                      variables: {
                                                        controlData: {
                                                          "framework": this.props.framework,
                                                          "highLevelCategory": this.props.humanHighLevelCategory,
                                                          "lowLevelCategory": this.props.lowLevelCategory,
                                                          "controlID": this.props.control.controlNanoID,
                                                          "referenceID": this.props.control.referenceID
                                                        }
                                                      }
                                                    })
                                                    break;
                                                  default:
                                                    break;
                                                }
                                              })
                                              this.setState({
                                                status: newValue
                                              });

                                              controlState({
                                                variables:{
                                                  controlData:{
                                                    "controlId":`${this.props.control.controlNanoID}`,
                                                    "categoryId":null,
                                                    "status": newStatus.qldbLabel,
                                                    "frameworkId":`${this.props.control.frameworkID}`,
                                                    "referenceId":this.props.control.referenceID,
                                                    "sectionId":`${this.props.control.lowLevelCategoryNanoID}`,
                                                    "tenantId":this.props.user['custom:tenant'],
                                                    "updatedBy":this.props.user.sub
                                                  }
                                                }
                                              })


                                            }}
                                            component={renderSelectField}
                                            options={stateOptions}
                                            defaultValue={this.state.status}
                                            clearable={false}
                                          />
                                        </div>
                                      )}
                                    </Mutation>
                                  )}
                                </Mutation>
                              )}
                            </Mutation>
                          )}
                        </Mutation>
                      )}
                    </Mutation>
                  )}
                </Mutation>
                )}
              </Mutation>
              </div>
            </div>
          </td>
          <td>
            <div className='form__form-group-icon'>
              <Link
                to='#'
                id={`comment-${this.props.control.controlNanoID}`}
                className='uploadEvidence link-column'
                onClick={e => {
                  e.preventDefault()
                  this.setState({ open: true });
                }}
                style={{ display: 'block' }}
              >Evidence/Comments</Link>
              <Link
                to='#'
                id={`help-me-${this.props.control.controlNanoID}`}
                className='link-column'
                onClick={(e) => {
                  e.preventDefault()
                  this.getHelpTextData(this.props.control.controlNanoID)
                  //this.setState({ hOpen: true });
                }}
                style={{ display: 'block' }}
              >Help Me</Link>
              {this.props.control.hasSolution &&
                <Link
                  to={`/app/marketplace?tag=${this.props.control.solutionTags
                    .join(',')
                    .toLowerCase()
                    .replace(/ /g, '-')}`}
                  id={`colutions-${this.props.control.controlNanoID}`}
                  className='link-column'
                  style={{ display: 'block' }}
                >Solutions</Link>
              }
            </div>
            <Modal
              modal={this.state.open}
              toggle={() => { this.setState({ open: !this.state.open }) }}
              color='primary'
              title='Evidence and Comments'
              name='comments'
              id={this.props.control.controlNanoID}
              clearField={this.clearCommentField.bind(this)}
              framework={this.props.framework}
              lowLevelCategory={this.props.lowLevelCategory}
              highLevelCategory={this.props.humanHighLevelCategory}
            >
            </Modal>
            <HelpTextModal
              modal={this.state.hOpen}
              toggle={() => { this.setState({ hOpen: !this.state.hOpen }) }}
              name='help-text'
              editUrl={`${this.props.framework}/${this.props.humanHighLevelCategory ? this.props.humanHighLevelCategory + '/' : ''}${require('base-64').encode(this.props.lowLevelCategory.replace(/[^\x20-\x7E]/gmi,""))}/${this.props.control.controlNanoID}`}
              id={this.props.control.controlNanoID}
              advice={this.props.control.advice ? this.props.control.advice
                : this.props.control.description}
              framework={this.props.framework}
              referenceID={this.props.control.referenceID}
              title={this.props.control.referenceID}
              body={this.state.helpTextData.data}
            />
          </td>
        </tr > :
        null
    )
  }
}

RenderRow.propTypes = {
  page: PropTypes.string.isRequired,
  control: PropTypes.shape({
    // description: PropTypes.string.isRequired
  }).isRequired
};

function mapStateToProps (state) {
  return {
    theme: state.theme,
    user: state.auth.user,
    sidebar: state.sidebar
  }
}

export default connect(mapStateToProps, { loadCompliance, signout })(reduxForm({
  form: 'render-row'
})(withRouter(withApollo(RenderRow))))



// WEBPACK FOOTER //
// ./src/components/compliance/renderRow.js